import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import VideoFeaturesSection from '../components/VideoFeaturesSection';
import React, { useState, useEffect } from 'react';
import ProductShowcase from '../components/ProductShowcase';
import Footer from '../components/Footer';
const Landing = () => {
  const [message, setMessage] = useState('');
  console.log(message);
  useEffect(() => {
    // Set page title
    document.title = 'Frames and Bows - Handcrafted Home Decor';

    const fetchAPI = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api`);
        const data = await response.json();
        setMessage(data.message);
      } catch (error) {
        console.error('Error fetching API:', error);
        setMessage('Failed to connect to API');
      }
    };
    
    fetchAPI();
  }, []);

  // Cleanup title when component unmounts
  useEffect(() => {
    return () => {
      document.title = 'Frames and Bows';
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Navbar */}
      <Navbar />
      <HeroSection/>
      <VideoFeaturesSection/>
      <ProductShowcase/>
      <Footer/>
    </div>
  );
};

export default Landing;
